import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Users, Trash2, Plus } from "lucide-react";

export const StaffCard = () => {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/staff").then(({ data }) => setRows(data)).catch(() => {});
  useEffect(() => {
    load();
  }, []);

  const add = async () => {
    setBusy(true);
    try {
      await api.post("/staff", form);
      setForm({ name: "", email: "", password: "" });
      toast.success("Akun kasir dibuat");
      load();
    } catch (e) {
      toast.error(errMsg(e, "Gagal membuat akun kasir"));
    } finally {
      setBusy(false);
    }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/staff/${id}`);
      toast.success("Akun kasir dihapus");
      load();
    } catch (e) {
      toast.error(errMsg(e, "Gagal menghapus"));
    }
  };

  return (
    <div
      className="bg-white border border-gray-200 rounded-2xl p-5 space-y-4"
      data-testid="staff-card"
    >
      <p className="font-display font-semibold flex items-center gap-2">
        <Users size={18} className="text-primary" /> Akun Kasir
      </p>
      <p className="text-xs text-muted-foreground">
        Kasir bisa melayani penjualan, meja, stok, dan pesanan online, tetapi tidak bisa membuka
        Laporan, Laba, dan Pengaturan.
      </p>
      <div className="space-y-2">
        {rows.map((r) => (
          <div
            key={r.id}
            className="flex items-center gap-2 bg-gray-50 rounded-xl px-3 py-2"
            data-testid={`staff-row-${r.id}`}
          >
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium truncate">{r.name}</p>
              <p className="text-xs text-muted-foreground truncate">{r.email}</p>
            </div>
            <Button
              size="icon"
              variant="ghost"
              data-testid={`delete-staff-${r.id}`}
              onClick={() => remove(r.id)}
            >
              <Trash2 size={16} className="text-red-500" />
            </Button>
          </div>
        ))}
        {!rows.length && (
          <p className="text-xs text-muted-foreground" data-testid="staff-empty">
            Belum ada akun kasir.
          </p>
        )}
      </div>
      <div className="grid sm:grid-cols-3 gap-2">
        <Input
          data-testid="staff-name-input"
          placeholder="Nama kasir"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
        <Input
          data-testid="staff-email-input"
          placeholder="email@contoh.com"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
        <Input
          data-testid="staff-password-input"
          type="password"
          placeholder="Kata sandi (min 6)"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
        />
      </div>
      <Button
        data-testid="add-staff-btn"
        disabled={busy || !form.email || !form.password}
        onClick={add}
      >
        <Plus size={15} className="mr-1" /> Tambah Kasir
      </Button>
    </div>
  );
};
